import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitPullRequestFiles } from '@/services/git/api';
import type { GitPrFile } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitPullRequestFiles(
  repoFullName: string | null | undefined,
  number: number | null | undefined,
): UseQueryResult<GitPrFile[], Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitPullRequestFiles', orgId, repoFullName, number],
    queryFn: () => fetchGitPullRequestFiles(orgId!, repoFullName!, number!),
    enabled: !!token && !!orgId && !!repoFullName && number != null,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
